// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.sidebar {
  list-style: none;
  padding: 0rem;
  width: 160px;
  background-color: rgba(250, 252, 252, 0.9);
  border-radius: 10px;
}
ul.sidebar :first-child:hover {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
ul.sidebar :last-child:hover {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
ul.sidebar :first-child.active {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
ul.sidebar :last-child.active {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
ul.sidebar li {
  padding: 8px 10px;
  height: 40px;
  cursor: pointer;
  border-radius: 2px;
  margin: 2px 0px;
  outline: none;
}
ul.sidebar li a {
  text-decoration: none;
  color: #111329;
}
ul.sidebar li.active {
  background-color: #111329;
  border-color: #111329;
  box-shadow: 1px 1px 1px rgba(77, 77, 77, 0.2);
  border-width: 0px;
  border-style: solid;
  color: white;
}
ul.sidebar li.active a {
  color: white;
}
ul.sidebar li:hover {
  background-color: #111329;
  color: white;
  cursor: pointer;
  box-shadow: 2px 2px 2px rgba(77, 77, 77, 0.2);
}
ul.sidebar li:hover a {
  color: white;
}

.order-btn {
  background-color: rgb(238, 70, 81);
  color: white !important;
  text-shadow: 1px 1px 1px grey;
  border-radius: 10px;
  border-color: rgb(238, 70, 81);
  width: 160px;
  display: block;
}

.quote-btn {
  background-color: rgb(238, 70, 81);
  color: white !important;
  text-shadow: 1px 1px 1px grey;
  border-radius: 10px;
  border-color: rgb(238, 70, 81);
  width: 161px;
  display: block;
}

.order-btn:hover {
  background-color: rgb(238, 70, 81);
  border-radius: 10px;
  box-shadow: 1px 2px 1px rgba(77, 77, 77, 0.4);
}

.quote-btn:hover {
  background-color: rgb(238, 70, 81);
  border-radius: 10px;
  box-shadow: 1px 2px 1px rgba(77, 77, 77, 0.4);
}

.sidebarMarginTop {
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/common/sidebar/sidebar.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAGA;EACI,gBAAA;EACA,aAAA;EACA,YAAA;EACA,0CAAA;EACA,mBAAA;AAFJ;AAKI;EACI,4BAAA;EACA,6BAAA;AAHR;AAMI;EACI,+BAAA;EACA,gCAAA;AAJR;AAOI;EACI,4BAAA;EACA,6BAAA;AALR;AAQI;EACI,+BAAA;EACA,gCAAA;AANR;AASI;EACI,iBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAPR;AASQ;EACI,qBAAA;EACA,cCjCM;AD0BlB;AAWI;EAEI,yBCvCU;EDwCV,qBCxCU;EDyCV,6CAAA;EACA,iBAAA;EACA,mBAAA;EACA,YChDS;ADsCjB;AAYQ;EACI,YAAA;AAVZ;AAgBI;EACI,yBCtDU;EDuDV,YC3DS;ED4DT,eAAA;EACA,6CAAA;AAdR;AAgBQ;EACI,YAAA;AAdZ;;AAuBA;EACI,kCCxEY;EDyEZ,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,8BC3EY;ED4EZ,YAAA;EACA,cAAA;AApBJ;;AAwBA;EACI,kCCnFY;EDoFZ,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,8BCtFY;EDuFZ,YAAA;EACA,cAAA;AArBJ;;AAyBA;EACI,kCC7FY;ED8FZ,mBAAA;EACA,6CAAA;AAtBJ;;AAyBA;EACI,kCCpGY;EDqGZ,mBAAA;EACA,6CAAA;AAtBJ;;AAyBA;EACI,eAAA;AAtBJ","sourcesContent":["@import '../../../scss/variables';\n@import '../../../scss/mixins';\n\nul.sidebar{\n    list-style: none;\n    padding: 0rem;\n    width: 160px;\n    background-color: rgba(250, 252, 252, 0.9);\n    border-radius: 10px;\n    // margin-top: 12px;\n\n    :first-child:hover{\n        border-top-left-radius: 10px;\n        border-top-right-radius: 10px;\n    }\n\n    :last-child:hover{\n        border-bottom-left-radius: 10px;\n        border-bottom-right-radius: 10px;\n    }\n\n    :first-child.active{\n        border-top-left-radius: 10px;\n        border-top-right-radius: 10px;\n    }\n\n    :last-child.active{\n        border-bottom-left-radius: 10px;\n        border-bottom-right-radius: 10px;\n    }\n\n    li {\n        padding: 8px 10px;\n        height: 40px;\n        cursor:pointer;\n        border-radius: 2px;\n        margin: 2px 0px;\n        outline: none;\n\n        a{\n            text-decoration: none;\n            color: $secondary-color;\n        }\n    }\n\n    li.active {\n\n        background-color: $secondary-color;\n        border-color: $secondary-color;\n        box-shadow: 1px 1px 1px rgba(77, 77, 77, 0.2);\n        border-width: 0px;\n        border-style: solid;\n        color: $selected-metal;\n\n        a{\n            color: white;\n        }\n    }\n\n    \n\n    li:hover{\n        background-color: $secondary-color;\n        color: $selected-metal;\n        cursor: pointer;\n        box-shadow: 2px 2px 2px rgba(77, 77, 77, 0.2);\n\n        a{\n            color: white;\n        }\n\n        \n    }\n\n  \n}\n\n.order-btn{\n    background-color: $primary-color;\n    color: $selected-metal !important;\n    text-shadow: 1px 1px 1px grey;\n    border-radius: 10px;\n    border-color: $primary-hover;\n    width: 160px;\n    display: block;\n    // margin-top: 5px;\n}\n\n.quote-btn{\n    background-color: $primary-color;\n    color: $selected-metal !important;\n    text-shadow: 1px 1px 1px grey;\n    border-radius: 10px;\n    border-color:  $primary-hover;\n    width: 161px;\n    display: block;\n    // margin-top: 5px;\n}\n\n.order-btn:hover{\n    background-color: $primary-hover;\n    border-radius: 10px;\n    box-shadow: 1px 2px 1px rgba(77, 77, 77, 0.4);\n}\n\n.quote-btn:hover{\n    background-color: $primary-color;\n    border-radius: 10px;\n    box-shadow: 1px 2px 1px rgba(77, 77, 77, 0.4);\n}\n\n.sidebarMarginTop{\n    margin-top: 5px;\n}","$fa-font-path: \"../../node_modules/font-awesome/fonts\";\n\n$background-color: #fff;\n$copyrightbackground-color: #111329;\n$selected-metal: white;\n$disabled-color: #777777;\n$primary-color: rgb(238, 70, 81);\n$primary-hover: rgb(238, 70, 81);\n$secondary-color: #111329;\n$secondary-scolor: #f0ad4e;\n$secondary-hover: #111329;\n$accept-color: #76d0f5;\n$accept-hover: #76d0f5;\n$reject-color: #f32314;\n$reject-hover: #d43f3a;\n$secondary-button-color: #eeeeee;\n\n$body-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$button-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$error-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$primary-font-color: #333333;\n$secondary-font-color: #777777;\n$title-font-size: 3rem;\n$title-font-weight: 400;\n$sub-title-font-size: 1.5rem;\n$sub-title-font-weight: 400;\n$heading-font-size: 2.25rem;\n$body-font-size: 1rem;\n$copyright-font-size: 10px;\n$top-navigation-font-size: 1rem;\n\n//bootstrap\n$spacer: 1rem !default;\n$spacers: (\n\t0: 0,\n\t1: $spacer,\n\t2: calc(\n\t\t$spacer * 2,\n\t),\n\t3: calc(\n\t\t$spacer * 3,\n\t),\n\t4: calc(\n\t\t$spacer * 4,\n\t),\n\t5: calc(\n\t\t$spacer * 5,\n\t),\n\t6: calc(\n\t\t$spacer * 6,\n\t),\n\t7: calc(\n\t\t$spacer * 7,\n\t),\n\t8: calc(\n\t\t$spacer * 8,\n\t),\n\t9: calc(\n\t\t$spacer * 9,\n\t),\n\t10: calc(\n\t\t$spacer * 10,\n\t),\n\t11: calc(\n\t\t$spacer / 5,\n\t),\n\t12: calc(\n\t\t$spacer / 2\n\t)\n) !default;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
